import React, { memo } from "react";
import MenuItemWithTooltip from "./MenuItemWithTooltip";

// Collapsible navigation group that propagates nesting and active-state context to its children.
const MenuSection = memo(
  ({
    title,
    icon,
    children,
    isExpanded,
    onToggle,
    menuId,
    parentIds = [],
    onCollapseOthers,
    activeMenuItems,
  }) => {
    const hasActiveChild = activeMenuItems?.has(menuId) || false;
    const sectionLevel = parentIds.length;
    const nestingClassName =
      sectionLevel > 0 ? `nesting-level-${sectionLevel}` : "";
    const menuThreadLineLeftPx = sectionLevel === 0 ? 26 : 18;
    const menuPathBarLeftPx = sectionLevel === 0 ? 10 : 8;

    return (
      <div
        className={`menu-section menu-section-level-${sectionLevel} ${
          isExpanded ? "has-expanded-drawer" : ""
        } ${hasActiveChild ? "has-active-child" : ""}`.trim()}
        style={{
          "--menu-thread-line-left": `${menuThreadLineLeftPx}px`,
          "--menu-path-bar-left": `${menuPathBarLeftPx}px`,
          "--menu-path-text-weight": "500",
        }}
        data-menu-id={menuId}
      >
        <div
          className="menu-trigger-wrapper"
          data-parent-ids={parentIds.join(",")}
        >
          <MenuItemWithTooltip
            icon={icon}
            text={title}
            onClick={() => onToggle?.(menuId)}
            isButton={true}
            hasSubmenu={true}
            isExpanded={isExpanded}
            showTooltip={false}
            className={`${hasActiveChild ? "has-active-child" : ""} ${nestingClassName}`.trim()}
            parentIds={parentIds}
            onCollapseOthers={onCollapseOthers}
            activeMenuItems={activeMenuItems}
          />
        </div>
        <div className={`submenu ${isExpanded ? "expanded" : ""}`}>
          {React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
              return child;
            }

            if (child.type === MenuSection) {
              return React.cloneElement(child, {
                parentIds: [...parentIds, menuId].filter(Boolean),
                onCollapseOthers,
                activeMenuItems,
              });
            }

            if (typeof child.type === "string") {
              return child;
            }

            return React.cloneElement(child, {
              parentIds: [...parentIds, menuId].filter(Boolean),
              onCollapseOthers,
              activeMenuItems,
            });
          })}
        </div>
      </div>
    );
  }
);

export default MenuSection;
